import React, {useMemo} from 'react';
import { Table } from 'react-bootstrap';
import _ from 'lodash';
import {divideDataForActive, indicatorsActiveType} from "../../../../helpers/indicators";
import IndicatorsDataTable from "../../../../components/Portfolio/Tabs/IndicatorsDataTable";

export default function PortfolioTabIndex({ data }) {
  const mappedPcs = data.pcs.map((p) => ({
    ...p,
    ...p.values.reduce((acc, value) => ({
      ...acc,
      [`${value.year}_plan`]: value.plan,
      [`${value.year}_projsPlan`]: value.projsPlan,
    }), {}),
  }));
  const years = _.chain(data.pcs.map((p) => p.values.map((v) => v.year)))
    .flatten().uniq().sort()
    .value();

  const {activeMappedPcs} = useMemo(()=>{
    return {activeMappedPcs: divideDataForActive(mappedPcs)}
  },[mappedPcs])

  return (
    <div>
      <Table striped className="read-view">
        <thead>
          <tr>
            <th>Наименование показателя</th>
            <th>Единицы измерения</th>
            {years.map((year) => (
              <>
                <th key={`${year}_plan`}>
                  План по портфелю
                  <br />
                  {year}
                </th>
                <th key={`${year}_projsPlan`}>
                  План, введенный по проектам
                  <br />
                  {year}
                </th>
              </>
            ))}
            <th>Ключевой</th>
          </tr>
        </thead>
        <tbody>
        <IndicatorsDataTable pcs={activeMappedPcs.active} type={indicatorsActiveType.active} years={years}/>
        <IndicatorsDataTable pcs={activeMappedPcs.notActive} type={indicatorsActiveType.notActive} years={years}/>
        </tbody>
      </Table>
    </div>
  );
}
